/**
 * CRM module defaults and helpers — Saudi (SAR / +966) product defaults.
 */
import { getBrandDefaultCurrency, getBrandCurrencySuffix } from './brandCurrency';
import { getBrandDefaultCountry, getBrandPhonePlaceholder, SAUDI_PHONE_PREFIX } from './brandCountry';

export const CRM_DEFAULT_CURRENCY = getBrandDefaultCurrency();
export const CRM_CURRENCY_SYMBOL = getBrandCurrencySuffix();
export const CRM_DEFAULT_COUNTRY = getBrandDefaultCountry();
export const CRM_DEFAULT_PHONE_PREFIX = SAUDI_PHONE_PREFIX;
export const CRM_DEFAULT_PHONE_PLACEHOLDER = getBrandPhonePlaceholder();

/** Saudi regions for territory / segmentation pickers. */
export const SAUDI_CRM_REGIONS = [
  'الرياض',
  'مكة المكرمة',
  'المدينة المنورة',
  'القصيم',
  'الشرقية',
  'عسير',
  'تبوك',
  'حائل',
  'الحدود الشمالية',
  'جazan',
  'نجران',
  'الباحة',
  'الجوف',
];

/** Default monthly sales quota for new agents (SAR). */
export const CRM_DEFAULT_SALES_QUOTA_SAR = 50000;

/** Pipeline stage keys (language-neutral ids). */
export const CRM_PIPELINE_STAGES = [
  { id: 'lead', labelKey: 'modules.crm.pipeline.stage_lead' },
  { id: 'qualified', labelKey: 'modules.crm.pipeline.stage_qualified' },
  { id: 'proposal', labelKey: 'modules.crm.pipeline.stage_proposal' },
  { id: 'negotiation', labelKey: 'modules.crm.pipeline.stage_negotiation' },
  { id: 'closed_won', labelKey: 'modules.crm.pipeline.stage_won' },
  { id: 'closed_lost', labelKey: 'modules.crm.pipeline.stage_lost' },
];

/** Arabic communication templates for Saudi CRM outreach. */
export const CRM_COMMUNICATION_TEMPLATES = {
  email: {
    welcome_lead: {
      subject: 'مرحباً بكم — شكراً لاهتمامكم',
      body: 'السلام عليكم {{name}}،\n\nشكراً لتواصلكم معنا. يسعدنا متابعة طلبكم وتقديم أفضل عرض يناسب احتياجاتكم.\n\nمع التحية،\nفريق المبيعات',
    },
    follow_up: {
      subject: 'متابعة — {{company}}',
      body: 'السلام عليكم {{name}}،\n\nنود متابعة اهتمامكم بخدماتنا. هل يناسبكم موعد للتواصل هذا الأسبوع؟\n\nمع التحية،\n{{agent_name}}',
    },
    deal_won: {
      subject: 'تم تأكيد الطلب — شكراً لثقتكم',
      body: 'السلام عليكم {{name}}،\n\nنشكركم على اختياركم لنا. تم تأكيد الصفقة بقيمة {{amount}} {{currency}}.\n\nمع التحية،\nفريق علاقات العملاء',
    },
  },
  sms: {
    new_lead: 'مرحباً {{name}}، شكراً لتواصلكم. سيتواصل معكم ممثلنا خلال 24 ساعة. — {{company}}',
    appointment_reminder: 'تذكير: موعدكم مع {{agent_name}} غداً الساعة {{time}}. للاستفسار: {{phone}}',
    follow_up_due: 'نود متابعة طلبكم. يرجى الرد أو التواصل على {{phone}}. — {{company}}',
  },
  whatsapp: {
    intro: 'السلام عليكم {{name}} 👋\n\nمعكم {{agent_name}} من {{company}}. يسعدنا خدمتكم ومساعدتكم في {{topic}}.',
    quote_ready: 'تم إعداد عرض السعر بقيمة {{amount}} {{currency}}. هل يناسبكم مراجعته اليوم؟',
    thank_you: 'شكراً لثقتكم بنا 🙏 نحن دائماً في خدمتكم.',
  },
};

/** Interpolate {{key}} placeholders in template strings. */
export function renderCrmTemplate(template, vars = {}) {
  if (!template) return '';
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    const val = vars[key];
    return val != null ? String(val) : '';
  });
}

/** Normalize API monetary fields to brand currency code. */
export function normalizeCrmCurrency(value) {
  return value || CRM_DEFAULT_CURRENCY;
}

export default {
  CRM_DEFAULT_CURRENCY,
  CRM_CURRENCY_SYMBOL,
  CRM_DEFAULT_COUNTRY,
  CRM_DEFAULT_PHONE_PREFIX,
  CRM_DEFAULT_PHONE_PLACEHOLDER,
  SAUDI_CRM_REGIONS,
  CRM_DEFAULT_SALES_QUOTA_SAR,
  CRM_PIPELINE_STAGES,
  CRM_COMMUNICATION_TEMPLATES,
  renderCrmTemplate,
  normalizeCrmCurrency,
};
